import { envConfig } from '#constants/envConfig';

/** Owns the async Capacitor subscription even if its caller logs out while it loads. */
export function watchNativeAppState(onChange: (active: boolean) => void): () => void {
  let disposed = false;
  let remove: (() => Promise<void>) | undefined;
  if (envConfig.IS_NATIVE) {
    void (async () => {
      let changed = false;
      try {
        const { App } = await import('@capacitor/app');
        if (disposed) return;
        const handle = await App.addListener('appStateChange', ({ isActive }) => {
          changed = true;
          if (!disposed) onChange(isActive);
        });
        remove = () => handle.remove();
        if (disposed) {
          await remove();
          return;
        }
        const state = await App.getState();
        // An event received during getState is newer than the snapshot.
        if (!disposed && !changed) onChange(state.isActive);
      } catch {
        // An older shell can fall back to web visibility after the native attempt fails.
        if (!disposed && !changed) onChange(true);
      }
    })();
  }
  return () => {
    disposed = true;
    void Promise.resolve(remove?.()).catch(() => {});
  };
}
